import { baseClient } from '../common';
import { ShopModel } from './shop.model';
import { StripeCustomerSessionModel } from './stripe-customer-session.model';

const apiUrl = `/api/shops`;

export const shopClient = {
  get: (shopId: string): Promise<ShopModel> => {
    return baseClient.get<ShopModel>(`${apiUrl}/${shopId}`);
  },

  getStripeCustomerSession: (
    shopId: string,
  ): Promise<StripeCustomerSessionModel> => {
    return baseClient.get<StripeCustomerSessionModel>(
      `${apiUrl}/${shopId}/stripe-customer-session`,
    );
  },
};
